// فایل: src/components/ShareProjectForm.tsx
import React, { useState } from 'react';
import { shareProject } from '../api/projects';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faSave } from "@fortawesome/free-solid-svg-icons";
interface ShareProjectFormProps {
  projectId: number;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: (displayName: string) => void;
}

const errorMessages: Record<string, string> = {
  EMPTY_USERNAME: "نام کاربری شما وارد نشده است.",
  EMPTY_TARGET: "نام کاربری مقصد را وارد کنید.",
  PROJECT_NOT_FOUND: "پروژه یافت نشد.",
  REQUESTER_NOT_FOUND: "کاربر شما یافت نشد.",
  NOT_OWNER: "فقط صاحب پروژه می‌تواند آن را به اشتراک بگذارد.",
  TARGET_USER_NOT_FOUND: "کاربر مقصد یافت نشد.",
  SELF_SHARE: "نمی‌توانید پروژه را با خودتان به اشتراک بگذارید.",
  ALREADY_SHARED: "این پروژه قبلاً با این کاربر به اشتراک گذاشته شده است.",
};

export default function ShareProjectForm({
  projectId,
  isOpen,
  onClose,
  onSuccess
}: ShareProjectFormProps) {
  const [targetUsername, setTargetUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleShare = async () => {
    if (!targetUsername.trim()) {
      setError('نام کاربری مقصد را وارد کنید.');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const result = await shareProject(projectId, targetUsername.trim());

      if (result.code === "SHARE_SUCCESS") {
        setSuccess(`پروژه با موفقیت با ${result.sharedWith.displayName} به اشتراک گذاشته شد.`);
        onSuccess(result.sharedWith.displayName);
        setTargetUsername('');
        setTimeout(() => onClose(), 1500);
      }
    } catch (err: any) {
      const code = err.message;
      setError(errorMessages[code] || "خطای ناشناخته در سرور");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;
  
  return (
    <div style={{ marginTop: 12 }}>
      {/* فرم ایجاد تسک */}
      <form >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            padding: 12,
            border: "1px solid #ddd",
            borderRadius: 8,
          }}
        >
          <input
            type="text"
            value={targetUsername}
            onChange={(e) => setTargetUsername(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && handleShare()}
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="مثال: sepehr"
            disabled={loading}
            autoFocus
          />
 {error && <p className="text-red-600 text-sm mb-3">{error}</p>}
        {success && <p className="text-green-600 text-sm mb-3">{success}</p>}

<button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 bg-gray-200 rounded hover:bg-gray-300 transition"
            disabled={loading}
          >
            انصراف
          </button>
          <button
            onClick={handleShare}
            disabled={loading || !targetUsername.trim()}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 transition"
          >
            {loading ? 'در حال ارسال...' : 'به اشتراک بگذار'}
          </button>
        </div>
      </form>

      {/* بخش حذف تسک 
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          padding: 12,
          marginTop: 12,
          border: "1px solid #f2dede",
          borderRadius: 8,
          background: "#fcf8e3",
        }}
      >
        <label style={{ fontWeight: 600 }}>حذف تسک</label>
        <input
          placeholder="Task ID برای حذف"
          value={deleteTaskId}
          onChange={(e) => setDeleteTaskId(e.target.value)}
          inputMode="numeric"
        />
        <button
          type="button"
          onClick={handleDelete}
          disabled={deleting}
          style={{ alignSelf: "center", color: "white", background: "#d9534f", padding: "6px 12px", borderRadius: 6 }}
        >
          <FontAwesomeIcon icon={faTrash} fontSize="20" />{" "}
          {deleting ? "در حال حذف..." : "حذف"}
        </button>
      </div>*/}
    </div>
  );
}
